import ProgressGoals from './ProgressGoals.container';

export default ProgressGoals;

export * from './+store';
